import { render, staticRenderFns } from "./attendanceMonitoring.vue?vue&type=template&id=96444836"
import script from "./attendanceMonitoring.vue?vue&type=script&lang=js"
export * from "./attendanceMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports